import { render, staticRenderFns } from "./SettingTooltip.vue?vue&type=template&id=51c31eae&scoped=true"
import script from "./SettingTooltip.vue?vue&type=script&lang=ts"
export * from "./SettingTooltip.vue?vue&type=script&lang=ts"
import style0 from "./SettingTooltip.vue?vue&type=style&index=0&id=51c31eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c31eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
